export class DatosMercado {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
